import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation } from "@tanstack/react-query";

export const CUSTOMER_SAP_EXPORT_RE_EXPORT_API_PATH = "/v1/customer-sap-export/re-export" as const;

export type CustomerSapExportReExportResponse =
  paths[typeof CUSTOMER_SAP_EXPORT_RE_EXPORT_API_PATH]["post"]["responses"][202]["content"]["application/json"];
export type CustomerSapExportReExportBody =
  paths[typeof CUSTOMER_SAP_EXPORT_RE_EXPORT_API_PATH]["post"]["requestBody"]["content"]["application/json"];

export const useCustomerSapExportReExportMutation = () => {
  return useMutation<CustomerSapExportReExportResponse, Error, CustomerSapExportReExportBody>({
    mutationFn: async (body) => {
      const response = await alphartisApiAxios.post<CustomerSapExportReExportResponse>(
        CUSTOMER_SAP_EXPORT_RE_EXPORT_API_PATH,
        body,
      );
      return response.data;
    },
  });
};
